module.exports = __webpack_public_path__ + "static/media/RA-AC0009S_01.fa7b98cb.png";